import $ from 'jquery';
import Swal from 'sweetalert2';
import { initGlobalSelect2 } from '../utils/select2-utils';

export function initInspeksiJtm() {
  const $pageId = $('#page-id');
  const baseUrl = $pageId.data('base-url') ? $pageId.data('base-url').replace(/\/$/, '') : '';

  // ── DataTables Reference (Initialized by global table-utils.js) ──
  const table = $.fn.dataTable.isDataTable('#tableInspeksi')
    ? $('#tableInspeksi').DataTable()
    : null;

  // ── Image Preview Logic ──
  $('.img-input').on('change', function () {
    const file = this.files[0];
    const preview = $(this).siblings('.preview-container');
    if (file) {
      const reader = new FileReader();
      reader.onload = function (e) {
        preview.find('img').attr('src', e.target.result);
        preview.removeClass('d-none');
      };
      reader.readAsDataURL(file);
    } else {
      preview.addClass('d-none');
    }
  });

  // ── Create Button ──
  $('#btnCreateInspeksi').on('click', function () {
    $('#formInspeksi')[0].reset();
    $('#id_inspeksi').val('');
    $('#id_tiang_hidden').val('');
    $('#search_tiang').val('').removeClass('is-valid is-invalid');
    $('#tiang_status').html('');
    $('#tiangInfoRow').hide();
    $('.preview-container').addClass('d-none');
    $('#modalInspeksiTitle').text('Input Inspeksi');
    $('#modalInspeksi').modal('show');
  });

  // ── Edit Button Click ──
  $(document).on('click', '.btn-edit-jtm', async function () {
    const url = $(this).data('url-json');
    if (!url) return;

    try {
      const response = await fetch(url);
      const result = await response.json();

      if (result.status === 'success') {
        const data = result.data;
        const modal = $('#modalInspeksi');

        // 1. Reset & Set Title
        $('#formInspeksi')[0].reset();
        $('#modalInspeksiTitle').text('Edit Inspeksi');

        // 2. Populate Standard Fields
        $('#id_inspeksi').val(data.id_inspeksi);
        $('[name="tanggal"]').val(data.tanggal);

        $('[name="id_pegawai"]').val(data.id_pegawai).trigger('change');
        $('[name="id_komponen"]').val(data.id_komponen).trigger('change');
        $('[name="id_kondisi"]').val(data.id_kondisi).trigger('change');
        $('[name="skala_prioritas"]').val(data.skala_prioritas).trigger('change');

        $('[name="keterangan"]').val(data.keterangan);
        $('#latitude').val(data.latitude);
        $('#longitude').val(data.longitude);

        // 3. Populate Tiang Search & Info Row
        $('#id_tiang_hidden').val(data.id_tiang);
        $('#search_tiang')
          .val(data.nomor_tiang || data.kode_tiang || '')
          .removeClass('is-valid is-invalid');
        $('#tiang_status').html('');

        $('#id_up3').val(data.id_up3);
        $('#display_up3').val(data.nama_up3 || '-');
        $('#id_ulp').val(data.id_ulp);
        $('#display_ulp').val(data.nama_ulp || '-');
        $('#id_penyulang').val(data.id_penyulang);
        $('#display_penyulang').val(data.nama_penyulang || '-');

        $('#tiangInfoRow').show();

        // 4. Handle Image Previews
        const prefixUrl = `${baseUrl}/inspeksi-jtm/image/`;

        if (data.foto_temuan) {
          const $preview = $('#foto_temuan').siblings('.preview-container');
          $preview.find('img').attr('src', prefixUrl + data.foto_temuan);
          $preview.removeClass('d-none');
        } else {
          $('#foto_temuan').siblings('.preview-container').addClass('d-none');
        }

        if (data.foto_pendukung) {
          const $preview = $('#foto_pendukung').siblings('.preview-container');
          $preview.find('img').attr('src', prefixUrl + data.foto_pendukung);
          $preview.removeClass('d-none');
        } else {
          $('#foto_pendukung').siblings('.preview-container').addClass('d-none');
        }

        // 5. Show Modal
        modal.modal('show');
      } else {
        Swal.fire('Error', result.message || 'Gagal memuat data formulir', 'error');
      }
    } catch (err) {
      console.error(err);
      Swal.fire('Error', 'Terjadi kesalahan jaringan saat memuat data', 'error');
    }
  });

  // ── Tiang Search & Autofill ──
  const $searchInput = $('#search_tiang');
  const $btnCheck = $('#btn_check_tiang');
  const $status = $('#tiang_status');
  const $idTiangHidden = $('#id_tiang_hidden');

  function checkTiang() {
    const val = $searchInput.val().trim();
    if (val.length < 3) {
      $status
        .html('Ketik minimal 3 karakter...')
        .removeClass('text-success text-danger')
        .addClass('text-muted');
      return;
    }

    $status
      .html('<span class="spinner-border spinner-border-sm text-primary me-1"></span> Mencari...')
      .removeClass('text-danger text-success')
      .addClass('text-primary');

    $.get(`${baseUrl}/tiang/ajax-search`, { q: val }, function (res) {
      if (res.status === 'success' && res.data.length > 0) {
        let data = res.data.find((item) => item.nomor_tiang === val);
        if (!data) data = res.data[0];

        $idTiangHidden.val(data.id_tiang);
        $status
          .html(
            '<i class="bi bi-check-circle-fill text-success me-1"></i> Tiang ditemukan: ' +
              (data.nomor_tiang || data.kode_tiang)
          )
          .removeClass('text-primary text-danger')
          .addClass('text-success');

        $('#tiangInfoRow').slideDown(200);
        $('#id_up3').val(data.id_up3);
        $('#display_up3').val(data.nama_up3 || '-');
        $('#id_ulp').val(data.id_ulp);
        $('#display_ulp').val(data.nama_ulp || '-');
        $('#id_penyulang').val(data.id_penyulang);
        $('#display_penyulang').val(data.nama_penyulang || '-');

        if (data.latitude) $('#latitude').val(data.latitude);
        if (data.longitude) $('#longitude').val(data.longitude);

        $searchInput.addClass('is-valid').removeClass('is-invalid');
      } else {
        $idTiangHidden.val('');
        $status
          .html(
            '<i class="bi bi-exclamation-triangle-fill text-danger me-1"></i> Tiang tidak ditemukan'
          )
          .removeClass('text-primary text-success')
          .addClass('text-danger');
        $('#tiangInfoRow').slideUp(200);
        $searchInput.addClass('is-invalid').removeClass('is-valid');
      }
    });
  }

  if ($btnCheck.length) {
    $btnCheck.on('click', checkTiang);
    $searchInput.on('keypress', function (e) {
      if (e.which === 13) {
        e.preventDefault();
        checkTiang();
      }
    });
  }

  // NOTE: Form submission is now handled by global-crud.js

  // ── Reset on modal closed ──
  $('#modalInspeksi').on('hidden.bs.modal', function () {
    $('#formInspeksi')[0].reset();
    $idTiangHidden.val('');
    $status.html('');
    $searchInput.val('').removeClass('is-valid is-invalid');
    $('#tiangInfoRow').hide();
    $('.preview-container').addClass('d-none');
    $('#btnSubmitInspeksi').prop('disabled', false).text('Simpan');
  });

  // NOTE: Bulk Delete is now handled by global-crud.js

  // ── Update Maps (Leaflet OpenSource) on detail modal ──
  let detailMap = null;
  let detailMarker = null;

  $('#modalDetail').on('shown.bs.modal', function () {
    const $modal = $(this);

    const lat = parseFloat($modal.find('[data-view-key="latitude"]').text());
    const lng = parseFloat($modal.find('[data-view-key="longitude"]').text());

    if (typeof L === 'undefined') {
      console.error('Leaflet library (L) is not loaded!');
      return;
    }

    // Fix for Leaflet default marker icons not loading correctly from CDN/Webpack
    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
      iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
      shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
    });

    if (!isNaN(lat) && !isNaN(lng)) {
      $('#map-detail').show();
      $('#btn-open-maps').attr('href', `https://www.google.com/maps?q=${lat},${lng}`).show();

      // Initialize or Update Leaflet Map
      try {
        if (!detailMap) {
          detailMap = L.map('map-detail', {
            zoomControl: true,
            attributionControl: false,
          }).setView([lat, lng], 15);

          L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
            maxZoom: 22,
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            attribution: 'Google Maps',
          }).addTo(detailMap);

          detailMarker = L.marker([lat, lng]).addTo(detailMap);
        } else {
          detailMap.setView([lat, lng], 15);
          detailMarker.setLatLng([lat, lng]);
        }

        // Critical for Leaflet inside Bootstrap Modals
        detailMap.invalidateSize();
      } catch (e) {
        console.error('Map initialization error:', e);
      }
    } else {
      $('#map-detail').hide();
      $('#btn-open-maps').hide();
    }
  });
}
